
import {defineComponent, PropType} from 'vue'
import { CtClient } from '@/models/interfaces/content-type'
import FulfillmentPricing from '@/pages/Channels/components/FulfillmentPricing.vue'
import PrintPackingSlips from '@/pages/Channels/components/PrintPackingSlips.vue'
import ChannelProducts from '@/pages/Channels/components/ChannelProducts.vue'

import SkuSettingsField from '@/components/SkuSettingsField.vue'
import ChannelSettings from '@/pages/Channels/components/ChannelSettings.vue'
import SkuSettings from '@/pages/Channels/components/SkuSettings.vue'
import SalesChannelSettings from '@/pages/Channels/components/SalesChannelSettings.vue'
import TrashIcon from '@/components/Icons/TrashIcon.vue'
import ClientChannels from '@/pages/Channels/components/ClientChannels.vue'
import ClientSettings from '@/pages/Channels/components/ClientSettings.vue'
import AddressSettings from '@/pages/Channels/components/AddressSettings.vue'
import BillingAddressSettings from '@/pages/Channels/components/BillingAddressSettings.vue'
import PaymentDetails from '@/pages/Channels/components/PaymentDetails.vue'
import AccountingDetails from '@/pages/Channels/components/AccountingDetails.vue'
import RegistrationDetails from '@/pages/Channels/components/RegistrationDetails.vue'
import InvoiceCustomization from '@/pages/Channels/components/InvoiceCustomization.vue'

export default defineComponent({
  name: 'ClientDetails',
  props: {
    client: {
      type: Object as PropType<CtClient>,
      required: true,
    },
    activeToggle: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    InvoiceCustomization,
    RegistrationDetails,
    AccountingDetails,
    PaymentDetails,
    BillingAddressSettings,
    AddressSettings,
    ClientSettings,
    ClientChannels,
    TrashIcon,
    SalesChannelSettings,
    SkuSettings,
    ChannelSettings,
    SkuSettingsField,
    ChannelProducts,
    PrintPackingSlips,
    FulfillmentPricing,
  },
  emits: ['update:client'],
  setup () {
    return {}
  }
})
